/**
 * BuildUpVisual Component
 * Visual representation of roof build-up layers
 */

import React from 'react';
import { Card } from '../ui/FormElements';

const BuildUpVisual = ({ spec, products }) => {
  const layers = [{ name: 'Deck / Substrate', color: 'bg-slate-600' }];
  
  // Add primer layer if needed
  if (spec.membraneType === 'rbm' && spec.deckPrimerId) {
    const primer = products.find(p => p.id === parseInt(spec.deckPrimerId));
    layers.push({ name: primer?.name || 'Deck Primer', color: 'bg-orange-700' });
  } else if (spec.vclId && spec.vclPrimerId && !spec.useExistingAsVcl) {
    const primer = products.find(p => p.id === parseInt(spec.vclPrimerId));
    layers.push({ name: primer?.name || 'VCL Primer', color: 'bg-orange-700' });
  }
  
  // Add VCL layer
  if (spec.vclId && !spec.useExistingAsVcl) {
    const vcl = products.find(p => p.id === parseInt(spec.vclId));
    layers.push({ name: vcl?.name || 'VCL', color: 'bg-blue-700' });
  } else if (spec.useExistingAsVcl) {
    layers.push({ name: 'Existing System (as VCL)', color: 'bg-blue-700/50' });
  }
  
  // Add insulation layer
  if (spec.insulationId) {
    const insulation = products.find(p => p.id === parseInt(spec.insulationId));
    const layerText = spec.insulationLayers > 1 ? ` (${spec.insulationLayers} layers)` : '';
    layers.push({
      name: `${insulation?.name || 'Insulation'} ${spec.insulationThickness}mm${layerText}`,
      color: 'bg-yellow-600'
    });
  }
  
  // Add membrane layer(s)
  if (spec.membraneType === 'single_ply' && spec.deckMembraneId) {
    const membrane = products.find(p => p.id === parseInt(spec.deckMembraneId));
    layers.push({ name: membrane?.name || 'Single Ply Membrane', color: 'bg-emerald-600' });
  } else if (spec.membraneType === 'rbm') {
    if (spec.deckUnderlayId) {
      layers.push({
        name: products.find(p => p.id === parseInt(spec.deckUnderlayId))?.name || 'RBM Underlay',
        color: 'bg-stone-700'
      });
    }
    if (spec.deckCapId) {
      layers.push({
        name: products.find(p => p.id === parseInt(spec.deckCapId))?.name || 'RBM Cap Sheet',
        color: 'bg-stone-600'
      });
    }
  }
  
  // Don't render if only substrate
  if (layers.length <= 1) return null;
  
  return (
    <Card title="Build-Up Preview">
      <div className="space-y-1">
        {[...layers].reverse().map((layer, idx) => (
          <div
            key={idx}
            className={`${layer.color} px-4 py-2 rounded text-white text-sm font-medium flex items-center justify-between`}
          >
            <span>{layer.name}</span>
            <span className="text-white/60 text-xs">Layer {layers.length - idx}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default BuildUpVisual;
